export const PROPERTY_GALLERY_CONTENT = {
    BACK_TO_DETAILS: "Powrót do szczegółów",
    NEXT_PHOTO: "Następne zdjęcie",
    PREV_PHOTO: "Poprzednie zdjęcie",
    SHOW_ALL_PHOTOS: "Pokaż wszystkie zdjęcia",
    MORE_PHOTOS_PLUS: "+",
    getMorePhotosLabel: (count: number) => String(count),
    getSlideImageAlt: (index: number) => `Zdjęcie ${index + 1}`,
    getModalImageAlt: (index: number, offerName: string) => `zdjęcie ${index + 1} w inwestycji ${offerName}`,
    getViewerCounterLabel: (currentIndex: number, total: number) => `Zdjęcie: ${currentIndex + 1} z ${total}`
} as const;
export const PROPERTY_GALLERY_CONTENT = {
    BACK_TO_DETAILS: "Powrót do szczegółów",
    NEXT_PHOTO: "Następne zdjęcie",
    PREV_PHOTO: "Poprzednie zdjęcie",
    SHOW_ALL_PHOTOS: "Pokaż wszystkie zdjęcia",
    MORE_PHOTOS_PLUS: "+",
    getMorePhotosLabel: (count: number) => String(count),
    getSlideImageAlt: (index: number) => `Zdjęcie ${index + 1}`,
    getModalImageAlt: (index: number, offerName: string) => `zdjęcie ${index + 1} w inwestycji ${offerName}`,
    getViewerCounterLabel: (currentIndex: number, total: number) => `Zdjęcie: ${currentIndex + 1} z ${total}`
} as const;
